module.exports = __webpack_public_path__ + "static/media/filter.27893ad9.svg";